import { SupportedReligion } from '@/enum'
import { HeaderIcon } from '@/types'
import { withBasePath } from '@/constants/site'

/** Public-folder SVG path (avoids Turbopack ?url imports returning React components). */
function headerIconPath(filename: string): string {
  return withBasePath(`/header-icons/${filename}.svg`)
}

export const HEADER_ICON_OPTIONS: HeaderIcon[] = [
  {
    id: 'ICON_001',
    meta: headerIconPath('001'),
    religion: SupportedReligion.Hinduism,
    isCustomisable: true,
  },
  {
    id: 'ICON_002',
    meta: headerIconPath('002'),
    religion: SupportedReligion.Hinduism,
    isCustomisable: true,
  },
  {
    id: 'ICON_004',
    meta: headerIconPath('004'),
    religion: SupportedReligion.Hinduism,
    isCustomisable: true,
  },
  {
    id: 'ICON_005',
    meta: headerIconPath('005'),
    religion: SupportedReligion.Hinduism,
    isCustomisable: true,
  },
  {
    id: 'ICON_006',
    meta: headerIconPath('006'),
    religion: SupportedReligion.Hinduism,
    isCustomisable: true,
  },
  {
    id: 'ICON_007',
    meta: headerIconPath('007'),
    religion: SupportedReligion.Hinduism,
    isCustomisable: false,
  },
  {
    id: 'ICON_031',
    meta: headerIconPath('031'),
    religion: SupportedReligion.Hinduism,
    isCustomisable: true,
  },
  {
    id: 'ICON_037',
    meta: headerIconPath('037'),
    religion: SupportedReligion.Hinduism,
    isCustomisable: true,
  },
  {
    id: 'ICON_038',
    meta: headerIconPath('038'),
    religion: SupportedReligion.Hinduism,
    isCustomisable: true,
  },
  {
    id: 'ICON_008',
    meta: headerIconPath('008'),
    religion: SupportedReligion.Buddhism,
    isCustomisable: false,
  },
  {
    id: 'ICON_010',
    meta: headerIconPath('010'),
    religion: SupportedReligion.Buddhism,
    isCustomisable: false,
  },
  {
    id: 'ICON_011',
    meta: headerIconPath('011'),
    religion: SupportedReligion.Buddhism,
    isCustomisable: true,
  },
  {
    id: 'ICON_012',
    meta: headerIconPath('012'),
    religion: SupportedReligion.Buddhism,
    isCustomisable: true,
  },
  {
    id: 'ICON_029',
    meta: headerIconPath('029'),
    religion: SupportedReligion.Buddhism,
    isCustomisable: true,
  },
  {
    id: 'ICON_032',
    meta: headerIconPath('032'),
    religion: SupportedReligion.Buddhism,
    isCustomisable: true,
  },
  {
    id: 'ICON_033',
    meta: headerIconPath('033'),
    religion: SupportedReligion.Buddhism,
    isCustomisable: true,
  },
  {
    id: 'ICON_034',
    meta: headerIconPath('034'),
    religion: SupportedReligion.Buddhism,
    isCustomisable: true,
  },
  {
    id: 'ICON_035',
    meta: headerIconPath('035'),
    religion: SupportedReligion.Buddhism,
    isCustomisable: true,
  },
  {
    id: 'ICON_017',
    meta: headerIconPath('017'),
    religion: SupportedReligion.Islam,
    isCustomisable: true,
  },
  {
    id: 'ICON_018',
    meta: headerIconPath('018'),
    religion: SupportedReligion.Islam,
    isCustomisable: true,
  },
  {
    id: 'ICON_030',
    meta: headerIconPath('030'),
    religion: SupportedReligion.Islam,
    isCustomisable: true,
  },
  {
    id: 'ICON_013',
    meta: headerIconPath('013'),
    religion: SupportedReligion.Christianity,
    isCustomisable: true,
  },
  {
    id: 'ICON_014',
    meta: headerIconPath('014'),
    religion: SupportedReligion.Christianity,
    isCustomisable: true,
  },
  {
    id: 'ICON_015',
    meta: headerIconPath('015'),
    religion: SupportedReligion.Christianity,
    isCustomisable: true,
  },
  {
    id: 'ICON_016',
    meta: headerIconPath('016'),
    religion: SupportedReligion.Christianity,
    isCustomisable: true,
  },
  {
    id: 'ICON_028',
    meta: headerIconPath('028'),
    religion: SupportedReligion.Christianity,
    isCustomisable: true,
  },
  {
    id: 'ICON_020',
    meta: headerIconPath('020'),
    religion: SupportedReligion.Sikhism,
    isCustomisable: true,
  },
  {
    id: 'ICON_021',
    meta: headerIconPath('021'),
    religion: SupportedReligion.Sikhism,
    isCustomisable: true,
  },
  {
    id: 'ICON_023',
    meta: headerIconPath('023'),
    religion: SupportedReligion.Jainism,
    isCustomisable: true,
  },
  {
    id: 'ICON_025',
    meta: headerIconPath('025'),
    religion: SupportedReligion.Jainism,
    isCustomisable: true,
  },
  {
    id: 'ICON_026',
    meta: headerIconPath('026'),
    religion: SupportedReligion.Jainism,
    isCustomisable: true,
  },
  {
    id: 'ICON_036',
    meta: headerIconPath('036'),
    religion: SupportedReligion.Jainism,
    isCustomisable: true,
  },
  {
    id: 'ICON_039',
    meta: headerIconPath('039'),
    religion: SupportedReligion.Hinduism,
    isCustomisable: true,
  },
  {
    id: 'ICON_040',
    meta: headerIconPath('040'),
    religion: SupportedReligion.Hinduism,
    isCustomisable: true,
  },
  {
    id: 'ICON_041',
    meta: headerIconPath('041'),
    religion: SupportedReligion.Hinduism,
    isCustomisable: true,
  },
]
